import { Component, OnInit, OnDestroy } from '@angular/core';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { ProfileMenuComponent } from '../profile-menu/profile-menu.component';
import { RouterOutlet } from '@angular/router';
import { ModalTempComponent } from '../modal-temp/modal-temp.component';
import { AuthService } from '../../services/auth.service';
import { MicarteraService } from '../../services/micartera.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { IdentificacionService } from '../../services/identificacion.service';
import { Subscription } from 'rxjs';
import { MenuDataService } from '../../services/menu-data.service';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    SidebarComponent,
    ProfileMenuComponent,
    RouterOutlet,
    ModalTempComponent,
  ],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private micarteraService: MicarteraService,
    private router: Router,
    private identificacionService: IdentificacionService,
    private menuData: MenuDataService
  ) {
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.identificacionService.resetClientCode();
      });
  }

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.micarteraService.initializeService();
      this.callMenu();
    }
  }

  callMenu() {
    this.menuData.getMenu().subscribe({
      next: () => {
        
      },
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
